import { Customer, GetCustomerResponse } from '../dto/Interfaces/CustomerDetail/ICustomerDetail';
import { CustomerSignal } from '../dto/Interfaces/ICustomerSignal';
import { ScoreCluster } from '../dto/Types/ScoreType';
import { colors } from './palette';
import { format } from 'date-fns';
import WhatsappIcon from '../components/Icons/Whatsapp';
import Google from '../components/Icons/Google';
import Pinterest from '../components/Icons/Pinterest';
import Apple from '../components/Icons/Apple';
import Ebay from '../components/Icons/Ebay';
import Yahoo from '../components/Icons/Yahoo';
import Instagram from '../components/Icons/Instagram';
import AirBnB from '../components/Icons/AirBnB';
import XIcon from '../components/Icons/XIcon';
import Amazon from '../components/Icons/Amazon';
import Telegram from '../components/Icons/Telegram';
import Microsoft from '../components/Icons/Microsoft';
import Spotify from '../components/Icons/Spotify';
import Deliveroo from '../components/Icons/Deliveroo';
import Hubspot from '../components/Icons/Hubspot';
import Wordpress from '../components/Icons/Wordpress';
import Linkedin2 from '../components/Icons/Linkedin2';
import Skype from '../components/Icons/Skype';
import Gravatar from '../components/Icons/Gravatar';
import FacebookIcon from '../components/Icons/Facebook';
import FlipkartIcon from '../components/Icons/Flipkart';
import BukalapakIcon from '../components/Icons/Bukalapak';
import ViberIcon from '../components/Icons/Viber';
import SnapchatIcon from '../components/Icons/Snapchat';
import Paypal from '../components/Icons/Paypal';
import Binance from '../components/Icons/Binance';
import DisneyPlus from '../components/Icons/DisneyPlus';
import Duolingo from '../components/Icons/Duolingo';
import Booking from '../components/Icons/Booking';
import Samsung from '../components/Icons/Samsung';
import Atlassian from '../components/Icons/Atlassian';
import Laspass from '../components/Icons/LastPass';
import Adobe from '../components/Icons/Adobe';
import Freelancer from '../components/Icons/Freelancer';
import { ChipStatus } from '../components/Chip';
import WeiboIcon from '../components/Icons/Weibo';
import GithubIcon from '../components/Icons/Github';
import { ScoreClusterLabelsCapitalized } from '../dto/Types/ScoreClusterLabelType';
import { IconsType, SocialIconsType, validIconNames, validSocialNames } from '../dto/Interfaces/IIconProps';
import GoogleAds from '../components/Icons/GoogleAds';
import Glassdoor from '../components/Icons/Glassdoor';
import {
  Battery20,
  Battery30,
  Battery50,
  Battery60,
  Battery80,
  Battery90,
  BatteryStd,
  CheckCircle,
  Error,
  Headphones,
  Mic,
  ReportProblem,
  Videocam,
  BatteryCharging20,
  BatteryCharging30,
  BatteryCharging50,
  BatteryCharging60,
  BatteryCharging80,
  BatteryCharging90,
  BatteryChargingFull,
} from '@mui/icons-material';
import { getCustomerTransformed } from '../api';
import JQuery from '../components/Icons/JQuery';
import GoogleTagManager from '../components/Icons/GoogleTagManager';
import GoogleAnalytics from '../components/Icons/GoogleAnalytics';
import PhpIcon from '../components/Icons/PhpIcon';
import RssIcon from '../components/Icons/RssIcon';
import CloudFlare from '../components/Icons/CloudFlare';
import MySql from '../components/Icons/MySQL';
import React from 'react';
import Puppeteer from '../components/Icons/Puppeteer';
import { Tooltip } from '@mui/material';
import Selenium from '../components/Icons/Selenium';
import Cypress from '../components/Icons/Cypress';
import Chromedp from '../components/Icons/Chromedp';
import PlayWright from '../components/Icons/Playwright';

export const getBattery = (value: string) => {
  const chargeValue = parseInt(value?.replace('%', ''), 10);

  if (chargeValue >= 0 && chargeValue < 30) {
    return ['battery20'];
  }
  if (chargeValue >= 30 && chargeValue < 50) {
    return ['battery30'];
  }
  if (chargeValue >= 50 && chargeValue < 60) {
    return ['battery50'];
  }
  if (chargeValue >= 60 && chargeValue < 80) {
    return ['battery60'];
  }
  if (chargeValue >= 80 && chargeValue < 90) {
    return ['battery80'];
  }
  if (chargeValue >= 90 && chargeValue < 100) {
    return ['battery90'];
  }
  if (chargeValue === 100) {
    return ['battery100'];
  }
  return [];
};
export const capitalizedLowercase = (s: string) => {
  const sectionsArray = s.trim().split(' ');
  const lowerSectionsArray = sectionsArray.map((section) => section.toLowerCase());
  const capitalizedSectionsArray = lowerSectionsArray.map((section) => capitalize(section));

  return capitalizedSectionsArray.join(' ');
};

export const parseSocialName = (name: string): SocialIconsType => {
  const lowerSocialName = name.toLowerCase();

  return validSocialNames.includes(lowerSocialName as SocialIconsType) ? (lowerSocialName as SocialIconsType) : 'empty';
};

export const parseIconName = (name: string): IconsType => {
  const lowerSocialName = name.toLowerCase();

  return validIconNames.includes(lowerSocialName as IconsType) ? (lowerSocialName as IconsType) : 'success';
};

export const getIcon = (name: IconsType) => {
  const rndString = createRandomSeed();
  switch (name.toLowerCase()) {
    case 'success':
      return <CheckCircle data-testid="success-icon" sx={{ color: colors.success.main }} key={rndString} />;
    case 'error':
      return <Error data-testid="error-icon" sx={{ color: colors.error.main }} key={rndString} />;
    case 'errorwarning':
      return <Error data-testid="errorwarning-icon" sx={{ color: colors.warning.main }} key={rndString} />;
    case 'errorunknown':
      return <Error data-testid="errorunknown-icon" sx={{ color: colors.gray4 }} key={rndString} />;
    case 'warning':
      return <ReportProblem data-testid="warning-icon" sx={{ color: colors.warning.main }} key={rndString} />;
    case 'mic':
      return <Mic data-testid="mic-icon" key={rndString} />;
    case 'headphones':
      return <Headphones data-testid="headphones-icon" key={rndString} />;
    case 'videocam':
      return <Videocam data-testid="videocam-icon" key={rndString} />;
    case 'battery20':
      return (
        <Tooltip title="Current battery 20%" arrow>
          <Battery20 data-testid="battery20-icon" key={rndString} />
        </Tooltip>
      );
    case 'batterycharging20':
      return (
        <Tooltip title="Current Battery 20% (Charging)" arrow>
          <BatteryCharging20 data-testid="batterycharging20-icon" key={rndString} />
        </Tooltip>
      );
    case 'battery30':
      return (
        <Tooltip title="Current battery 30%" arrow>
          <Battery30 data-testid="battery30-icon" key={rndString} />
        </Tooltip>
      );
    case 'batterycharging30':
      return (
        <Tooltip title="Current battery 30% (Charging)" arrow>
          <BatteryCharging30 data-testid="batterycharging30-icon" key={rndString} />
        </Tooltip>
      );
    case 'battery50':
      return (
        <Tooltip title="Current battery 50%" arrow>
          <Battery50 data-testid="battery50-icon" key={rndString} />
        </Tooltip>
      );
    case 'batterycharging50':
      return (
        <Tooltip title="Current battery 50% (Charging)" arrow>
          <BatteryCharging50 data-testid="batterycharging50-icon" key={rndString} />
        </Tooltip>
      );
    case 'battery60':
      return (
        <Tooltip title="Current battery 60%" arrow>
          <Battery60 data-testid="battery60-icon" key={rndString} />
        </Tooltip>
      );
    case 'batterycharging60':
      return (
        <Tooltip title="Current battery 60% (Charging)" arrow>
          <BatteryCharging60 data-testid="batterycharging60-icon" key={rndString} />
        </Tooltip>
      );
    case 'battery80':
      return (
        <Tooltip title="Current battery battery 80%" arrow>
          <Battery80 data-testid="battery80-icon" key={rndString} />
        </Tooltip>
      );
    case 'batterycharging80':
      return (
        <Tooltip title="Current battery 80% (Charging)" arrow>
          <BatteryCharging80 data-testid="batterycharging80-icon" key={rndString} />
        </Tooltip>
      );
    case 'battery90':
      return (
        <Tooltip title="Current battery 90%" arrow>
          <Battery90 data-testid="battery90-icon" key={rndString} />
        </Tooltip>
      );
    case 'batterycharging90':
      return (
        <Tooltip title="Current battery 90% (Charging)" arrow>
          <BatteryCharging90 data-testid="batterycharging90-icon" key={rndString} />
        </Tooltip>
      );
    case 'battery100':
      return (
        <Tooltip title="Current battery 100%" arrow>
          <BatteryStd data-testid="battery100-icon" key={rndString} />
        </Tooltip>
      );
    case 'batterycharging100':
      return (
        <Tooltip title="Current battery 100% (Charging)" arrow>
          <BatteryChargingFull data-testid="batterycharging100-icon" key={rndString} />
        </Tooltip>
      );
    default:
      return <>-</>;
  }
};

export const dotsFormat = (x: number, digits?: number) => {
  let _digits = digits;
  if (digits === 0) _digits = undefined;
  const floatString = _digits !== undefined ? Math.round(x).toFixed(_digits) : Math.round(x).toString();
  const decimalDigits = _digits !== undefined ? floatString.substring(floatString.length - 1 - _digits).substring(1) : undefined;
  const intString = _digits !== undefined ? floatString.substring(0, floatString.length - 1 - _digits) : floatString;

  return `${intString.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}${decimalDigits !== undefined ? `,${decimalDigits}` : ''}`;
};

export const getSocialIcon = (name: SocialIconsType, secondaryColor?: string) => {
  const rndString = createRandomSeed();
  switch (name) {
    case 'adobe':
      return <Adobe color={colors.white} size={25} key={rndString} secondaryColor={secondaryColor} />;
    case 'airbnb':
      return <AirBnB color={colors.white} size={25} key={rndString} />;
    case 'amazon':
      return <Amazon color={colors.white} size={25} key={rndString} />;
    case 'apple':
      return <Apple color={colors.white} size={25} key={rndString} />;
    case 'atlassian':
      return <Atlassian color={colors.white} size={25} key={rndString} />;
    case 'binance':
      return <Binance color={colors.white} size={25} key={rndString} />;
    case 'booking':
      return <Booking color={colors.white} size={25} key={rndString} secondaryColor={secondaryColor} />;
    case 'bukalapak':
      return <BukalapakIcon color={colors.white} size={25} key={rndString} />;
    case 'chromedp':
      return <Chromedp color={colors.white} size={24} key={rndString} />;
    case 'cloudflare':
      return <CloudFlare color={colors.white} size={25} key={rndString} />;
    case 'cypress':
      return <Cypress size={25} key={rndString} />;
    case 'deliveroo':
      return <Deliveroo color={colors.white} size={25} key={rndString} />;
    case 'disneyplus':
      return <DisneyPlus color={colors.white} size={25} key={rndString} />;
    case 'duolingo':
      return <Duolingo color={colors.white} size={25} key={rndString} secondaryColor={secondaryColor} />;
    case 'ebay':
      return <Ebay color={colors.white} size={25} key={rndString} />;
    case 'facebook':
      return <FacebookIcon color={colors.white} size={25} key={rndString} />;
    case 'flipkart':
      return <FlipkartIcon color={colors.white} size={25} key={rndString} />;
    case 'freelancer':
      return <Freelancer color={colors.white} size={25} key={rndString} />;
    case 'github':
      return <GithubIcon color={colors.white} size={32} key={rndString} />;
    case 'glassdoor':
      return <Glassdoor color={colors.white} size={22} key={rndString} />;
    case 'google':
      return <Google color={colors.white} size={25} key={rndString} />;
    case 'google analytics':
      return <GoogleAnalytics color={colors.white} size={25} key={rndString} />;
    case 'googleads':
      return <GoogleAds color={colors.white} size={22} key={rndString} />;
    case 'google tag manager':
      return <GoogleTagManager color={colors.white} size={22} key={rndString} />;
    case 'gravatar':
      return <Gravatar color={colors.white} size={25} key={rndString} />;
    case 'jquery':
      return <JQuery color={colors.white} size={25} key={rndString} />;
    case 'hubspot':
      return <Hubspot color={colors.white} size={25} key={rndString} />;
    case 'instagram':
      return <Instagram color={colors.white} size={22} key={rndString} />;
    case 'lastpass':
      return <Laspass color={colors.white} size={25} key={rndString} secondaryColor={secondaryColor} />;
    case 'linkedin':
      return <Linkedin2 color={colors.white} size={30} key={rndString} />;
    case 'microsoft':
      return <Microsoft color={colors.white} size={21} testid={name} key={rndString} />;
    case 'mysql':
      return <MySql color={colors.white} size={32} key={rndString} />;
    case 'office365':
      return <Microsoft color={colors.white} size={21} testid={name} key={rndString} />;
    case 'paypal':
      return <Paypal color={colors.white} size={25} key={rndString} />;
    case 'php':
      return <PhpIcon color={colors.white} size={28} key={rndString} secondaryColor={secondaryColor} />;
    case 'playwright':
      return <PlayWright color={colors.white} size={28} key={rndString} />;
    case 'pinterest':
      return <Pinterest color={colors.white} size={25} key={rndString} />;
    case 'puppeteer':
      return <Puppeteer color={colors.white} size={25} key={rndString} secondaryColor={secondaryColor} />;
    case 'rss':
      return <RssIcon color={colors.white} size={30} key={rndString} secondaryColor={secondaryColor} />;
    case 'samsung':
      return <Samsung color={colors.white} size={25} key={rndString} />;
    case 'selenium':
      return <Selenium color={colors.white} size={24} key={rndString} />;
    case 'skype':
      return <Skype color={colors.white} size={25} key={rndString} secondaryColor={secondaryColor} />;
    case 'snapchat':
      return <SnapchatIcon color={colors.white} size={25} key={rndString} />;
    case 'spotify':
      return <Spotify color={colors.white} size={25} key={rndString} />;
    case 'telegram':
      return <Telegram color={colors.white} size={25} key={rndString} />;
    case 'twitter':
      return <XIcon color={colors.white} size={25} key={rndString} secondaryColor={secondaryColor} />;
    case 'viber':
      return <ViberIcon color={colors.white} size={30} key={rndString} secondaryColor={secondaryColor} />;
    case 'weibo':
      return <WeiboIcon color={colors.white} size={25} key={rndString} />;
    case 'wordpress':
      return <Wordpress color={colors.white} size={25} key={rndString} />;
    case 'whatsapp':
      return <WhatsappIcon color={colors.white} size={25} key={rndString} />;
    case 'yahoo':
      return <Yahoo color={colors.white} size={25} key={rndString} />;
    default:
      return <React.Fragment key={rndString}></React.Fragment>;
  }
};

export const createRandomSeed = (): string => {
  return Math.floor(Math.random() * 10000000).toString();
};
export const maxScore = 1000;
export const minScore = 0;

export type ScoreThreshold = [min: number, max: number];
export const scoreThresholds: Record<ScoreCluster, ScoreThreshold> = {
  very_high: [776, 1000],
  high: [551, 775],
  review: [451, 550],
  low: [226, 450],
  very_low: [0, 225],
};
export const fixedDigitsFormat = (x: number, digits: number) => {
  const floatString = x?.toFixed(digits);
  const decimalDigits = floatString?.substring(floatString.length - 1 - digits)?.substring(1);
  const intString = digits !== 0 ? floatString?.substring(0, floatString.length - 1 - digits) : floatString;
  if (intString === '-0' && decimalDigits === '00') return '0,00';
  return `${intString?.replace(/\B(?=(\d{3})+(?!\d))/g, '.')}${digits !== 0 ? `,${decimalDigits}` : ''}`;
};

export const getScoreClusterFromScore = (score: number): ScoreCluster => {
  if (score >= scoreThresholds.very_high[0]) {
    return 'very_high';
  } else if (score >= scoreThresholds.high[0]) {
    return 'high';
  } else if (score >= scoreThresholds.review[0]) {
    return 'review';
  } else if (score >= scoreThresholds.low[0]) {
    return 'low';
  } else {
    return 'very_low';
  }
};

export const getScoreLabel = (scoreLabel: ScoreCluster): ScoreClusterLabelsCapitalized => {
  switch (scoreLabel) {
    case 'very_low':
      return 'Poor';
    case 'low':
      return 'Bad';
    case 'review':
      return 'Moderate';
    case 'high':
      return 'Good';
    case 'very_high':
      return 'High';
  }
};

export const getScoreChipVariant = (scoreLabel: ScoreCluster): ChipStatus => {
  switch (scoreLabel) {
    case 'very_low':
      return 'error';
    case 'low':
      return 'error';
    case 'review':
      return 'warning';
    case 'high':
      return 'success';
    case 'very_high':
      return 'success';
  }
};
export const getScoreValue = (label: string | null): ScoreCluster => {
  switch (label) {
    case 'Poor':
      return 'very_low';
    case 'Bad':
      return 'low';
    case 'Moderate':
      return 'review';
    case 'Good':
      return 'high';
    case 'High':
      return 'very_high';
    default:
      return 'very_low';
  }
};

export const getScoreColor = (scoreLabel: ScoreCluster): string => {
  switch (scoreLabel) {
    case 'very_low':
      return colors.error.main;
    case 'low':
      return colors.error.main;
    case 'review':
      return colors.warning.main;
    case 'high':
      return colors.success.main;
    case 'very_high':
      return colors.success.main;
  }
};

export const getChipStatusFromCluster = (scoreCluster: ScoreCluster): ChipStatus => {
  switch (scoreCluster) {
    case 'very_low':
    case 'low':
      return 'error';
    case 'review':
      return 'warning';
    case 'high':
    case 'very_high':
      return 'success';
    default:
      return 'unknown';
  }
};

export const labelToThreshold = (scoreLabel: ScoreCluster): ScoreThreshold => {
  return scoreThresholds[scoreLabel];
};

export const getSignalsArrayAndTurnIntoObject = <T extends readonly string[]>(
  signalsArray: CustomerSignal[],
  signalKeys: T,
  returnEmptyValue?: boolean
): { [key in T[number]]: CustomerSignal } => {
  const arrayOfSignals = signalKeys.map((signalKey) => {
    const signal = signalsArray.find((signal) => signal.id === signalKey);
    const val = signal?.value || '-';
    return {
      [signalKey]: {
        id: signalKey,
        value: returnEmptyValue ? '-' : val,
        description: signal?.description || '-',
        signal: signal?.signal || '-',
        negative: signal?.negative || false,
        taxonomies: signal?.taxonomies || [],
      },
    };
  });

  return Object.assign({}, ...arrayOfSignals);
};

// Define the response type for the transformCustomerResponse function
interface TransformedCustomerResponse {
  item: Customer | 'loading';
}

// Externalized transformResponse function
export const transformCustomerResponse = (response: GetCustomerResponse): TransformedCustomerResponse => {
  if (response.item === 'loading') {
    return { item: 'loading' };
  }
  const customer = response.item;
  return { item: getCustomerTransformed(customer) };
};

export const createUrl = (value: string, isGravatar: boolean) => {
  let imageUrl = `${value}?${performance.now()}`;
  if (isGravatar) {
    imageUrl = `https://www.gravatar.com/avatar/${value}?d=404`;
  }
  return imageUrl;
};

export const capitalize = (s: string) => {
  return s.charAt(0).toUpperCase() + s.slice(1).toLowerCase();
};

export const dotFormat = (d: Date): string => {
  return format(d, 'dd.MM.yyyy');
};

export const returnThemeSpacingAsNumber = (val: string): number => {
  return parseFloat(val);
};

export const getEmailImg = (customer: Customer): string => {
  const googleImg = customer.signals['email-google-profile-picture'].value;
  const skypeEmailImg = customer.signals['email-skype-profile-picture'].value;
  const gravatarImg = customer.signals['email-gravatar-profile-picture'].value;
  const socialImg = customer.signals['email-social-avatar'].value;
  if (googleImg !== '-') return googleImg;
  if (skypeEmailImg !== '-') return skypeEmailImg;
  if (gravatarImg !== '-') return gravatarImg;
  if (socialImg !== '-') return socialImg;
  return '-';
};
export const getPhoneImg = (customer: Customer): string => {
  const whatsappImg = customer.webProfiles.profiles.find((el) => el.name === 'whatsapp' && el.tags.includes('phone'))?.url || '-';
  const telegramImg = customer.webProfiles.profiles.find((el) => el.name === 'telegram' && el.tags.includes('phone'))?.url || '-';
  const skypePhoneImg = customer.signals['phone-skype-profile-picture'].value;
  if (whatsappImg !== '-') return whatsappImg;
  if (telegramImg !== '-') return telegramImg;
  if (skypePhoneImg !== '-') return skypePhoneImg;
  return '-';
};

export const getImgFromEmailAndPhone = (customer: Customer): string => {
  const imgFromEmail = getEmailImg(customer);
  const imgFromPhone = getPhoneImg(customer);
  return imgFromEmail !== '-' ? imgFromEmail : imgFromPhone !== '-' ? imgFromPhone : '-';
};
